import { Component, Input } from '@angular/core';
import { SharedService } from 'app/shared/services/shared.service';
import { ModalsService } from 'app/shared/services/modals.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';
import { MacrosService, MacroTypes, MacroList } from 'app/shared/services/macros.service';

@Component({
  selector: 'available-macros-component',
  templateUrl: './available-macros.component.html',
  styleUrls: ['./available-macros.component.scss'],
})
export class AvailableMacrosComponent {
  @Input() public data: any;
  public macros: MacroList;

  constructor(
    public sharedService: SharedService,
    public modalsService: ModalsService,
    public ga: GoogleAnalyticsService,
    public macrosService: MacrosService
  ) {
    this.macros = [];
  }

  ngOnChanges($event: any) {
    const type: MacroTypes = $event.data.currentValue.type;
    this.macros = this.macrosService.getMacros(type);
  }
}
